import { render, staticRenderFns } from "./RightsHoldersLinkForm.vue?vue&type=template&id=1b49734a&"
import script from "./RightsHoldersLinkForm.vue?vue&type=script&lang=js&"
export * from "./RightsHoldersLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports